import PropTypes from 'prop-types';
import React from 'react';

export default function Logout(props) {
    props.logout();
    return <noscript />;
}

Logout.propTypes = {
    logout: PropTypes.func.isRequired,
    localContent: PropTypes.array.isRequired,
    termId: PropTypes.number.isRequired,
    routeToTerm: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/logout.ui.jsx